import type { CSSProperties } from "react";

/**
 * Custom Properties als Inline-Style. React kennt sie nicht im Typ, deshalb
 * genau hier einmal die Umgehung – statt an jeder Aufrufstelle zu casten.
 *
 * Über diesen Weg kommen die Farben aus dem Bundle in die CSS Modules: die
 * Fingerfarben sind Daten, keine Designentscheidung.
 */
export function cssVar(values: Record<string, string | undefined>): CSSProperties {
  const gefiltert = Object.entries(values).filter(([, v]) => v !== undefined);
  return Object.fromEntries(gefiltert) as CSSProperties;
}
